export function useCookieNotice() {
  const showNotice = useState('cookie-notice-open', () => false)

  const openNotice = () => {
    showNotice.value = true
  }

  const closeNotice = () => {
    showNotice.value = false
  }

  return { showNotice, openNotice, closeNotice }
}